import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent, Typography } from '@guildeducationinc/recess';
import { Button as MuiButton } from '@mui/material';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useBlocker } from 'react-router-dom';
export const ConfirmLeavePage = ({ isDirty, onConfirm, onCancel, useMui, }) => {
    const { t } = useLocale();
    const blocker = useBlocker(isDirty);
    const handleCancel = () => {
        onCancel && onCancel();
        if (blocker.state === 'blocked') {
            blocker.reset();
        }
    };
    const handleConfirm = () => {
        onConfirm && onConfirm();
        if (blocker.state === 'blocked') {
            blocker.proceed();
        }
    };
    if (blocker.state !== 'blocked') {
        return null;
    }
    return (_jsxs(Dialog, { title: t('Confirm Navigation'), isOpen: true, onClose: handleCancel, children: [_jsx(DialogContent, { children: _jsx(Typography, { variant: 'body1', children: t('You have unsaved changes. Are you sure you want to leave this page?') }) }), _jsx(DialogActions, { fullScreen: true, children: (useMui && (_jsxs(_Fragment, { children: [_jsx(MuiButton, { variant: 'outlined', onClick: handleCancel, children: t('Cancel') }), _jsx(MuiButton, { variant: 'contained', onClick: handleConfirm, color: 'primary', children: t('Leave') })] }))) || (_jsxs(_Fragment, { children: [_jsx(TrackableButton, { enText: 'Cancel', tag: 'confirm_leave_page_modal', appearance: 'outline', onClick: handleCancel, children: t('Cancel') }), _jsx(TrackableButton, { enText: 'Leave', tag: 'confirm_leave_page_modal', onClick: handleConfirm, color: 'primary', children: t('Leave') })] })) })] }));
};
